import { Component } from "@angular/core"
import { App, LoadingController, AlertController, ToastController } from "ionic-angular"

import firebase from "firebase"

import { RegisterPage } from "../register"

@Component({
  selector: "login-page",
  templateUrl: "index.html",
})
export class LoginPage {

  user: any = {}

  constructor(
    private appCtrl: App,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController
  ) {}

  onLogin() {

    if (!this.user.email || !this.user.password) {
      this.alertCtrl.create({
        message: "Por favor informe seu e-mail e sua senha",
        buttons: ["Ok"]
      }).present()
      return
    }

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.present()

    firebase.auth().signInWithEmailAndPassword(this.user.email, this.user.password)
      .then((response) => {

        loading.dismiss()
      })
      .catch((error) => {

        loading.dismiss()

        this.alertCtrl.create({
          message: "Dados inválidos",
          buttons: [
            {
              text: "Tentar novamente",
            },
            {
              text: "Esqueci minha senha",
              handler: () => this.onForgotPassword(),
            },
          ]
        }).present()
      })
  }

  onForgotPassword() {

    this.alertCtrl.create({
      title: "Recuperação de senha",
      message: "Informe seu e-mail no campo abaixo para redefinir sua senha",
      inputs: [
        {
          name: "email",
          placeholder: "E-mail",
        }
      ],
      buttons: [
        {
          text: "Enviar",
          handler: (data) => this.sendPasswordResetEmail(data.email),
        },
        {
          text: "Cancelar",
          role: "cancel",
        }
      ]
    }).present()
  }

  onRegister() {

    this.appCtrl.getRootNavs()[0].setRoot(RegisterPage, {}, {animate: true, direction: "forward"})
  }

  sendPasswordResetEmail(email) {

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.present()

    firebase.auth().sendPasswordResetEmail(email)
      .then(() => {

        loading.dismiss()

        this.toastCtrl.create({
          message: "E-mail enviado para " + email,
          duration: 3000,
        }).present()
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          title: "Falha ao enviar e-mail",
          message: "Verifique se você informou seu e-mail corretamente",
          buttons: ["Ok"],
        }).present()
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/index.ts